import { BreadCrumbItem } from '../BreadCrumbItem';
import { BreadCrumbItemProps } from '../BreadCrumbItem';

export type TemplateProps = React.HTMLAttributes<HTMLOListElement> & {
	items: BreadCrumbItemProps[];
};

export const Template: React.FC<TemplateProps> = ({
	items,
	className,
	...props
}) => (
	<ol
		style={{ lineHeight: '100%', textAlign: 'center' }}
		{...props}
		className={`breadcrumb text-truncate header-bread-crumb-template${
			className ? ` ${className}` : ''
		}`}
	>
		{items.map((item, key) => (
			<BreadCrumbItem {...item} key={key} />
		))}
	</ol>
);
